import { useWatch } from "react-hook-form"
import { Lens } from "@hookform/lenses"
import { CareProviderContent } from "@/modules/patients/detail/progress-note/point-of-care/components/fields/care-provider-content"
import { ReasonForChoosingType } from "@/modules/patients/detail/progress-note/point-of-care/components/fields/reason-for-choosing-type"
import { TimeToTreatContent } from "@/modules/patients/detail/progress-note/point-of-care/components/fields/time-to-treat-content"
import { PointOfCareFormType } from "@/modules/patients/detail/progress-note/point-of-care/schema"
import type { ContentProps, HasCareProvider } from "@/modules/patients/detail/progress-note/point-of-care/types"

type EmergencyContentProps = ContentProps & HasCareProvider & { pointOfCareFormLens: Lens<PointOfCareFormType> }

export const EmergencyContent = (props: EmergencyContentProps) => {
  const { pointOfCareFormLens, isActual, timeToTreatData, countryCode, hasCareProvider } = props
  const timeToTreatLens = pointOfCareFormLens.focus("timeToTreatType")
  const timeToTreatType = useWatch(timeToTreatLens.interop())
  return (
    <div className="col-span-2 gap-4">
      {isActual && (
        <ReasonForChoosingType reasonForChoosingTypeLens={pointOfCareFormLens.focus("reasonForChoosingType")} />
      )}
      <div className="flex flex-col gap-4 pt-4 @lg/patient-layout:flex-row">
        <TimeToTreatContent timeToTreatLens={timeToTreatLens} timeToTreatData={timeToTreatData} />
        <div className="@lg/patient-layout:w-2/3">
          {countryCode === "CH" && (
            <CareProviderContent
              pointOfCareFormLens={pointOfCareFormLens}
              searchType="MEDICAL_EMERGENCY_OR_PERMANENCE"
              hasCareProvider={hasCareProvider}
              timeToTreat={timeToTreatType ?? undefined}
              allowUnknownCareProvider
            />
          )}
        </div>
      </div>
    </div>
  )
}
